import React from 'react';
import {primaryButtonSx} from '../caregiver_form/utils/button_styles';

import {Avatar, Box, Button, Paper, Stack, Typography} from 'views/components';
import {Mail} from 'views/icons';
import {Translate} from 'views/module';

const WelcomeScreen = () => {
  const [isGoToHomeLoading, setIsGoToHomeLoading] = React.useState(false);

  const goToHome = async () => {
    setIsGoToHomeLoading(true);
    window.location.assign('https://www.carequilt.ca');
    setIsGoToHomeLoading(false);
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(180deg, #F6F2EF 0%, #F4EFEA 100%)',
        minHeight: '100dvh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowX: 'clip',
      }}
    >
      <Stack paddingBottom={{xs: 8, sm: 20}}>
        <Box
          width={{md: 576, xs: '100%'}}
          maxWidth={{md: 576, xs: '100%'}}
          marginX='auto'
        >
          <Stack spacing={{xs: 3, sm: 4}}>
            <Stack spacing={{xs: 1.5, sm: 1}}>
              <Paper
                sx={{
                  padding: '24px',
                  background: 'white',
                  borderRadius: '20px',
                  boxShadow: 'none',
                }}
              >
                <Stack spacing={{xs: 2, sm: 2.5}}>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: '28px',
                      fontFamily: 'Spectral Light',
                      color: '#2D2925',
                      lineHeight: '128%',
                      letterSpacing: '-2%',
                    }}
                  >
                    <Translate expression='form.Final.Title' />
                  </Typography>
                  {/* Static Info 1 */}
                  <Stack direction='row' spacing='20px' alignItems='center'>
                    <Avatar sx={{bgcolor: 'primary.light', borderRadius: '20px', p: 2}}>
                      <Mail sx={{color: '#DA7955'}}/>
                    </Avatar>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: {xs: '16px', sm: '18px'},
                          color: '#2D2925',
                          lineHeight: '128%',
                          letterSpacing: '-2%',
                        }}
                      >
                        <Translate expression='form.Final.WeReview.Title' />
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize: '16px',
                          lineHeight: '150%',
                        }}
                      >
                        <Translate expression='form.Final.WeReview.Details' />
                      </Typography>
                    </Box>
                  </Stack>
                  {/* Static info 2 */}
                  <Stack direction='row' spacing='20px' alignItems='center'>
                    <Avatar sx={{bgcolor: 'primary.light', borderRadius: '20px', p: 2}}>
                      <Box
                        component='img'
                        src='/icons/flowbite_users-solid.png'
                        alt=''
                        sx={{width: 24, height: 24}}
                      />
                    </Avatar>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: {xs: '16px', sm: '18px'},
                          color: '#2D2925',
                          lineHeight: '128%',
                          letterSpacing: '-2%',
                        }}
                      >
                        <Translate expression='form.Final.SetUpProfile.Title' />
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize: '16px',
                          lineHeight: '150%',
                        }}
                      >
                        <Translate expression='form.Final.SetUpProfile.Details' />
                      </Typography>
                    </Box>
                  </Stack>
                  {/* Static info 3 */}
                  <Stack direction='row' spacing='20px' alignItems='center'>
                    <Avatar sx={{bgcolor: 'primary.light', borderRadius: '20px', p: 2}}>
                      <Box
                        component='img'
                        src='/icons/mdi_offer.png'
                        alt=''
                        sx={{width: 24, height: 24}}
                      />
                    </Avatar>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: {xs: '16px', sm: '18px'},
                          color: '#2D2925',
                          lineHeight: '128%',
                          letterSpacing: '-2%',
                        }}
                      >
                        <Translate expression='form.Final.CareOffers.Title' />
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize: '16px',
                          lineHeight: '150%',
                        }}
                      >
                        <Translate expression='form.Final.CareOffers.Details' />
                      </Typography>
                    </Box>
                  </Stack>
                  {/* Button */}
                  <Box textAlign='end'>
                    <Button
                      onClick={goToHome}
                      disabled={isGoToHomeLoading}
                      loading={isGoToHomeLoading}
                      sx={{
                        ...primaryButtonSx,
                        'paddingInline': {xs: '16px', sm: '36px'},
                      }}
                    >
                      <Translate expression='form.Common.Finish' />
                    </Button>
                  </Box>
                </Stack>
              </Paper>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default React.memo(WelcomeScreen);
